
import {FC} from "react";

import React from 'react';

import PPAPAceptForm from "../../forms/ppap/ppap-accept-form";

interface Interface{
    requestId: any;
    mode?: "Edit" | "Add new";
    onClose?: () => void;
}

interface Interface{
    requestId: any;
    mode?: "Edit" | "Add new";
    onClose?: () => void;
}

const PPAPAcceptScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <PPAPAceptForm
                    requestId={props.requestId}
                />
            
    );
}
export default PPAPAcceptScreen;
